<template>
  <svg
    width="73"
    height="81"
    viewBox="0 0 73 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M18.25 19.1842C18.25 29.7611 26.4382 38.3684 36.5 38.3684C46.5618 38.3684 54.75 29.7611 54.75 19.1842C54.75 8.60731 46.5618 0 36.5 0C26.4382 0 18.25 8.60731 18.25 19.1842ZM68.9444 81H73V76.7368C73 60.2853 60.2615 46.8947 44.6111 46.8947H28.3889C12.7344 46.8947 0 60.2853 0 76.7368V81H68.9444Z"
      fill="#E6E7E9"
    />
  </svg>
</template>

<script>
export default {
  name: 'WhiteUserIcon73'
};
</script>

<style scoped>

</style>